import { FormLabel } from '@Components/Common/FormComponent';
import TextEllipsis from '@Components/Common/Tooltip/TextEllipsis';
import { checkActionByType } from '@Policy/utils/fns';
import { ActionEnum } from '@Policy/utils/types';
import {
  Modal,
  Flex,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Stack,
  Textarea,
  ModalFooter,
} from '@tonic-one/react';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const EditableActionModal = (props: {
  action: ActionEnum;
  subjectTag: string;
  disclaimer: string;
  name: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (actionLabel: string) => void;
}) => {
  const { action, subjectTag, disclaimer, name, isOpen, onClose, onConfirm } =
    props;
  const { t } = useTranslation();
  const [label, setLabel] = useState<string>(
    action === ActionEnum.tagSubject ? subjectTag : disclaimer
  );

  const handleValidate = useCallback(() => {
    const checkResult = checkActionByType(label, action);
    if (checkResult) {
      window.showNotification({
        titleMsg: checkResult.title,
        bodyMsg: checkResult.content,
        severity: 'error',
      });
      return false;
    }
    return true;
  }, [label, action]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      closeOnEsc
      closeOnOutsideClick
      isClosable
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {action === ActionEnum.tagSubject
            ? t('policy.riskAi.rule.action.subjectTag')
            : t('policy.riskAi.rule.action.disclaimer')}
        </ModalHeader>
        <ModalBody>
          <Stack gap="4x">
            <Flex>
              <FormLabel label={t('common.label.enterName')} />
              <TextEllipsis>{name}</TextEllipsis>
            </Flex>
            <Flex>
              <FormLabel
                label={
                  action === ActionEnum.tagSubject
                    ? `${t('common.label.subjectTag')}`
                    : `${t('common.label.disclaimer')}`
                }
                required
              />
              {action === ActionEnum.tagSubject ? (
                <Input
                  value={label}
                  maxWidth="365px"
                  onChange={(e) => setLabel(e.currentTarget.value)}
                />
              ) : (
                <Textarea
                  value={label}
                  resize="vertical"
                  width="480px"
                  minHeight="100px"
                  onChange={(e) => setLabel(e.currentTarget.value)}
                />
              )}
            </Flex>
          </Stack>
        </ModalBody>
        <ModalFooter columnGap="2x">
          <Button
            variant="primary"
            onClick={() => {
              if (handleValidate()) onConfirm(label);
            }}
          >
            {t('common.button.save')}
          </Button>
          <Button onClick={onClose}>{t('common.button.cancel')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
